<div class="col-xl-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="tab nav-border" style="position: relative;">
        <div class="d-block d-md-flex justify-content-between">
          <div class="d-block w-100">
            <h5 class="card-title border-0 pb-0">لغو ماموریت</h5>
          </div>
          <div class="d-block d-md-flex nav-tabs-custom">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                  aria-controls="months" aria-selected="true">ثبت لغو ماموریت</a>
              </li>
              <li class="nav-item">
                <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                  aria-controls="months" aria-selected="true">درخواست لغو ماموریت</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
            <div class="row mb-30">

              <div class="col-md-12 mb-30" style="margin-top: 20px;">
                <div class="card card-statistics h-100">
                  <div class="card-body">

                    <div class="row">
                      <div class="form-group col-md-6">
                        <label for="exampleInputEmail1">شماره نامه</label>
                        <input [(ngModel)]="Filter_Letter" name="Filter_Letter" type="number" class="form-control"
                          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-6">
                        <button *ngIf="!Procssing"  type="button" (click)="ReadData_Schedules()" class="btn btn-info"
                          style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>

                        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
                      </div>
                    </div>



                    <div class="table-responsive">
                      <table class="mb-0 table table-bordered table-3 text-center table-striped">
                        <thead style="background-color: #489b39; color: white;">
                          <tr>
                            <th>#</th>
                            <th>شماره حکم</th>
                            <th>شماره نامه</th>
                            <th>نام مشتری</th>
                            <th>تاریخ</th>
                            <th>ساعت</th>
                            <th>امکانات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of DataList_Schedules">
                            <td>{{DataList_Schedules.indexOf(item)+1}}</td>
                            <td>{{item.code2}}</td>
                            <td>{{item.code}}</td>
                            <td>{{item.customerName}}</td>
                            <td>{{item.persianDate}}</td>
                            <td>{{item.clock}}</td>
                            <td>
                              <button ype="button" (click)="openModal(template,item)" class="btn btn-danger">لغو
                                ماموریت</button>
                            </td>

                          </tr>
                        </tbody>
                      </table>
                    </div>


                  </div>
                </div>
              </div>


            </div>

          </div>
          <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">

            <br />
            <br />

            <div class="row">
              <div class="form-group col-md-6">
                <button type="button" *ngIf="!InProccessing_SchedulesUser" (click)="ReadData_SchedulesUser()" class="btn btn-info"
                  style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>

                <img *ngIf="InProccessing_SchedulesUser" src="assets/Loading.gif" style="width: 25px;" />
              </div>
            </div>

            <div class="table-responsive">
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <thead style="background-color: #489b39; color: white;">
                  <tr>
                    <th>#</th>
                    <th>شماره حکم</th>
                    <th>شماره نامه</th>
                    <th>نام مشتری</th>
                    <th>تاریخ</th>
                    <th>سرپرست</th>
                    <th>شرح درخواست</th>
                    <th>امکانات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of DataList_SchedulesUser">
                    <td>
                      <p *ngIf="item.dscVisible">{{DataList_SchedulesUser.indexOf(item)+1}}</p>
                      <span *ngIf="!item.dscVisible" class="badge badge-pill badge-info float-right mt-1">جدید</span>
                    </td>
                    <td>{{item.code2}}</td>
                    <td>{{item.code}}</td>
                    <td>{{item.customerName}}</td>
                    <td>{{item.persianDate}}</td>
                    <td>{{item.activity_user}}</td>
                    <td>{{item.activity_date}}</td>
                    <td>
                      <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            امکانات
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModalCancelScheduleRequest(templateCancelScheduleRequest,item,1)"><i class="fa fa-check"></i> تایید </a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModalCancelScheduleRequest(templateCancelScheduleRequest,item,-1)"><i class="fa fa fa-times-rectangle"></i> عدم تایید </a>
                        </div>
                    </div>

                    </td>

                  </tr>
                </tbody>
              </table>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>
</div>



<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید لغو حکم ماموریت با شماره <b>{{Data_Seleted_Cancel.code2}}</b> </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Cancel.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> توضیحات </label>
        <input [(ngModel)]="Filter_Dsc" name="Filter_Dsc" type="text" class="form-control "
          placeholder="اینجا تایپ کنید ...">
      </div>

    </div>

  </div>
  <div class="modal-footer">
    <button type="button" [disabled]="!Filter_Dsc" class="btn btn-warning" (click)="Cancel(Data_Seleted_Cancel)"> لغو
      ماموریت <i class="fa fa-times-circle"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Cancel.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCancelScheduleRequest>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete_Status==-1" class="modal-title pull-left"> عدم تایید لغو حکم با شماره '{{DataList_SchedulesUser_Record.code2}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete_Status==1" class="modal-title pull-left">  تایید لغو حکم با شماره '{{DataList_SchedulesUser_Record.code2}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CancelScheduleRequest.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input [(ngModel)]="OperationDsc_CancelScheduleRequest"  name="OperationDsc_CancelScheduleRequest" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete_Status==-1" type="button" class="btn btn-danger" (click)="Answer_CancelScheduleRequest()"> عدم تایید <i class="fa fa-times-rectangle"></i></button>
    <button *ngIf="Data_Seleted_Delete_Status==1" type="button" class="btn btn-success" (click)="Answer_CancelScheduleRequest()"> تایید <i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CancelScheduleRequest.hide()">بستن</button>
  </div>
</ng-template>
